import { fmtEur } from "@/lib/format";
import { Card } from "@/components/ui/card";

function StatementTable({ title, rows }) {
  return (
    <Card className="p-0 overflow-hidden">
      <div className="px-5 py-3 border-b border-border/60 bg-secondary/50">
        <h3 className="font-heading font-semibold text-sm uppercase tracking-wide">{title}</h3>
      </div>
      <table className="w-full text-sm">
        <tbody>
          {rows.map((r, i) => {
            const isSection = r.value === null;
            return (
              <tr
                key={i}
                className={`border-b border-border/40 last:border-0 ${r.bold ? "bg-accent/40" : "hover:bg-accent/30"} transition-colors`}
                data-testid={`stmt-row-${i}`}
              >
                <td className={`px-5 py-2.5 ${r.bold ? "font-semibold" : ""} ${isSection ? "text-primary uppercase text-xs tracking-wider font-bold pt-4" : ""}`}>
                  {r.label}
                </td>
                <td className={`px-5 py-2.5 text-right font-mono ${r.bold ? "font-semibold" : ""} ${(r.value ?? 0) < 0 ? "text-red-500" : ""}`}>
                  {isSection ? "" : fmtEur(r.value)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Card>
  );
}

export function SintesiTab({ analysis }) {
  if (!analysis) return null;
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <StatementTable title="Stato Patrimoniale Riclassificato (Criterio Finanziario)" rows={analysis.reclass_sp} />
      <StatementTable title="Conto Economico Riclassificato (Valore Aggiunto)" rows={analysis.reclass_ce} />
    </div>
  );
}
